(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-registry-form"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function load() {
      if (!window.jQuery) return setTimeout(load, 100);
      
      // function to move cart note field
      const cartNoteMover = function() {
        const rfHolderEl = document.getElementById('cartNoteHolder');
        const rfNoteInput = document.getElementById('CartSpecialInstructions');
        if (rfNoteInput) {
          rfNoteEl = rfNoteInput.closest('.field');
          if (rfNoteEl) {
            rfHolderEl.appendChild(rfNoteEl);
            rfNoteInput.setAttribute('aria-labelledby', 'CartSpecialInstructions');
            const rfNoteLabel = rfNoteInput.nextElementSibling;
            rfNoteLabel.innerText = 'Include your gift message here. All gifts will be wrapped.';
          }
        }
      }
      
      // Save helper function: handle fetch errors
      const handleErrors = function(response) {
        if (!response.ok) {
          // If the response status is not OK, throw an error
          throw new Error(`Status: ${response.status}`);
        }
        return response;
      }
  
      // Save helper function: set classes and attributes to status message
      const setElementAttributes = function(elementId, content, className, ariaLive, role) {
        const element = document.getElementById(elementId);
        const dismissBtn = document.getElementById('dismissStatusBtn');
        if (element) {
          element.innerHTML = content;
          element.className = className || '';
          element.setAttribute('aria-live', ariaLive || '');
          element.setAttribute('role', role || '');
          dismissBtn.style.display = 'inline-block';
          dismissBtn.focus();
        }
      }
  
      // Dismiss status message function
      $('#dismissStatusBtn').on('click', function (e) {
        this.style.display = 'none';
        document.getElementById('statusMessage').className = '';
        document.getElementById('tmacSaveBtn').focus();
      });
      
      // function to hide and show - updated with accessible ARIA labels
      $(function() {
        let rfRegistrantName = $('#registrant-name').val();
        let rfRegistryPurchase = ( rfRegistrantName !== "" );
        // Hiding and showing
        if ( !rfRegistryPurchase && $('#delivery-choice').val() === "Select One" ) {
          $('#expandingFieldsGroup').attr('aria-expanded','false');
          $('.rfHide').hide();
          $('.rfHide').attr('aria-hidden','true');
        } else {
          $('#regGiftButton').hide();
          $('#regGiftButton').attr('aria-hidden','true');
          $('#expandingFieldsGroup').attr('aria-expanded','true');
          $('.optional-message').hide();
          $('.optional-message').attr('aria-hidden','true');
          cartNoteMover(); // move the cart note field in with registry fields
          $('.extra-info').addClass('rf-expanded');
        }
        //Trim note whitespace
        $( '#CartSpecialInstructions' ).val(function(index,value) {
          return value.trim();
        });
  
        $('#regGiftButton').on('click', function(e) {
            e.preventDefault();
            $('.rfHide').show().attr('aria-hidden','false');
            $('#regGiftButton').hide().attr('aria-hidden','true');
            $('#expandingFieldsGroup').attr('aria-expanded','true');
            $('.optional-message').hide().attr('aria-hidden','true');
            cartNoteMover(); // move the cart note field in with registry fields
            $('.extra-info').addClass('rf-expanded');
            $('#delivery-choice').focus();
        });
  
        // Save Choices button handler
        $('#tmacSaveBtn').on('click', function (e) {
          e.preventDefault();
          let delivery = $('#delivery-choice').val();
          let shower = $('#shower-details').val();
          let registrantName = $('#registrant-name').val();
          let ordernote = $('#CartSpecialInstructions').val();
          console.log(ordernote);
          // Use fetch to save choices
          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              attributes: {
                "Delivery Choice": delivery,
                "Shower Details": shower,
                "registrant_name": registrantName
              },
              note: ordernote
            })
          })
            .then(handleErrors)
            .then(response => {
              setElementAttributes('statusMessage', 'Success, your choices were saved.', 'save-success', 'polite', 'status');
            })
            .catch(error => {
              const errorMessage = `Error: ${error.message} - please call us at <a href="tel:501-327-2182">(501) 327-2182</a> for assistance.`;
              setElementAttributes('statusMessage', errorMessage, 'save-error', 'assertive', 'alert');
              console.error(error); // Log the error for further debugging if needed
            });
        });
  
      });
    }, false);
  
  } catch(e) { console.error(e); }
})();
})();
